// A canary merchant's own escape hatch back to the Phase I surface.
//
// Flipping the MOOP_PHASE_II toggle off is an operator action; this lets the merchant leave on their
// own when something in the new surface blocks them. It cannot be a plain link: PhaseILandingRedirect
// bounces Phase II users off /opportunity-overview, so the opt-out has to be a flag that guard reads.
//
// sessionStorage, not localStorage: an escape hatch should not outlive the tab and quietly become the
// merchant's permanent experience. Storage access is wrapped because Safari private mode throws.

const KEY = 'moop:use-legacy';

export const isLegacyOptIn = (): boolean => {
  try {
    return window.sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const setLegacyOptIn = (): void => {
  try {
    window.sessionStorage.setItem(KEY, '1');
  } catch {
    // Storage unavailable — the redirect will pull the merchant back to /campaigns. Failing closed
    // keeps them on the surface the toggle says they should be on.
  }
};

export const clearLegacyOptIn = (): void => {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to clean up if storage was never writable.
  }
};
